const host = process.env.REACT_APP_API_HOST;
const chatAISimulationHost = process.env.REACT_APP_CHAT_AI_SIMULATION_HOST;

interface TEndpoints {
    [key: string]: {
        [key: string]: {
            path: string;
            method: 'get' | 'post' | 'put' | 'delete';
        };
    };
}

const endpoints: TEndpoints = {
    users: {
        refreshToken: {
            path: '/Users/refresh-token',
            method: 'post',
        },
        revokeToken: {
            path: '/Users/revoke-token',
            method: 'post',
        },
        forgotPassword: {
            path: '/Users/ForgotPassword',
            method: 'post',
        },
        resetPassword: {
            path: '/Users/ResetPassword',
            method: 'put',
        },
        login: {
            path: '/Users/login',
            method: 'post',
        },
        registerGoogle: {
            path: '/Users/RegisterGoogle',
            method: 'post',
        },
    },
    hubs: {
        all: {
            path: '/Hubs',
            method: 'get',
        },
        stats: {
            path: '/HubStats/getall',
            method: 'get',
        },
        brief: {
            path: '/HubDoc',
            method: 'get',
        },
        getLocationsByCountry: {
            path: '/Hubs/GetLocationsByCountry',
            method: 'post',
        },
    },
    skill: {
        getTopSkills: {
            path: '/Skill/GetTopSkills',
            method: 'post',
        },
        exportTopSkills: {
            path: '/Skill/ExportTopSkills',
            method: 'post',
        },
        getTopSkillsByISCO4: {
            path: '/Skill/GetTopSkillsByISCO4',
            method: 'post',
        },
        exportTopSkillsByISCO4: {
            path: '/Skill/ExportTopSkillsByISCO4',
            method: 'post',
        },
    },
    companySetting: {
        getCompanySetting: {
            path: '/CompanySetting/GetCompanySetting',
            method: 'get',
        },
    },
    dashboard: {
        getJobSources: {
            path: '/Dashboard/GetJobSources',
            method: 'post',
        },
        getRegions: {
            path: '/Dashboard/GetRegions',
            method: 'get',
        },
        getSectorsList: {
            path: '/Dashboard/GetSectorList',
            method: 'get',
        },
        getSectorScore: {
            path: '/Dashboard/GetSectorScore',
            method: 'get',
        },
    },
    heatMap: {
        getHeatMapInfo: {
            path: '/HeatMap/GetHeatMapInfo',
            method: 'post',
        },
    },
    laborDemandPulse: {
        getTopEmployersByQuarter: {
            path: '/LaborDemandPulse/GetTopEmployersByQuarter',
            method: 'post',
        },
        exportTopEmployersByQuarter: {
            path: '/LaborDemandPulse/ExportTopEmployersByQuarter',
            method: 'post',
        },
        getTreeMapInfo: {
            path: '/LaborDemandPulse/GetTreeMapInfo',
            method: 'post',
        },
        exportTreeMapInfo: {
            path: '/LaborDemandPulse/ExportTreeMapInfo',
            method: 'post',
        },
        getTopSectorAndOccupationYearOnYear: {
            path: '/LaborDemandPulse/GetTopSectorAndOccupationYearOnYear',
            method: 'post',
        },
        exportTopSectorsAndOccupationYearOnYear: {
            path: '/LaborDemandPulse/ExportTopSectorsAndOccupationYearOnYear',
            method: 'post',
        },
        getUnemployedJobPosts: {
            path: '/LaborDemandPulse/GetUnemployedJobPosts',
            method: 'post',
        },
        exportUnemployedJobPosts: {
            path: '/LaborDemandPulse/ExportUnemployedJobPosts',
            method: 'post',
        },
        exportTopUnemployedJobPosts: {
            path: '/LaborDemandPulse/ExportTopUnemployedJobPosts',
            method: 'post',
        },
    },
    educationCareerPath: {
        getTopSpecializationsByDemandJobPostView: {
            path: '/EducationCareerPath/GetTopSpecializationsByDemandJobPostView',
            method: 'post',
        },
        exportTopSpecializationsByDemandJobPostView: {
            path: '/EducationCareerPath/ExportTopSpecializationsByDemandJobPostView',
            method: 'post',
        },
        getTopEmployersByISCED4: {
            path: '/EducationCareerPath/GetTopEmployersByISCED4',
            method: 'post',
        },
        exportTopEmployersByISCED4: {
            path: '/EducationCareerPath/ExportTopEmployersByISCED4',
            method: 'post',
        },
        getEducationLevelPercentage: {
            path: '/EducationCareerPath/GetEducationLevelPercentage',
            method: 'post',
        },
        getSpecializationList: {
            path: '/EducationCareerPath/getSpecializationList',
            method: 'get',
        },
        getTopSpecializationsByDemand: {
            path: '/EducationCareerPath/GetTopSpecializationsByDemand',
            method: 'post',
        },
        exportTopSpecializationsByDemand: {
            path: '/EducationCareerPath/ExportTopSpecializationsByDemand',
            method: 'post',
        },
        getTopSpecializationsByDemandGraduatesView: {
            path: '/EducationCareerPath/GetTopSpecializationsByDemandGraduatesView',
            method: 'post',
        },
        exportTopSpecializationsByDemandGraduatesView: {
            path: '/EducationCareerPath/ExportTopSpecializationsByDemandGraduatesView',
            method: 'post',
        },
        getTopSectorAndOccupationByISCED4: {
            path: '/EducationCareerPath/GetTopSectorAndOccupationByISCED4',
            method: 'post',
        },
        exportTopSectorAndOccupationByISCED4: {
            path: '/EducationCareerPath/ExportTopSectorAndOccupationByISCED4',
            method: 'post',
        },
        getCareerPathwayByISCED4: {
            path: '/EducationCareerPath/GetCareerPathwayByISCED4',
            method: 'post',
        },
        exportCareerPathwayByISCED4: {
            path: '/EducationCareerPath/ExportCareerPathwayByISCED4',
            method: 'post',
        },
        getYearlySpecializationAndSupplyTrend: {
            path: '/EducationCareerPath/GetYearlySpecializationAndSupplyTrend',
            method: 'post',
        },
        exportYearlySpecializationAndSupplyTrend: {
            path: '/EducationCareerPath/ExportYearlySpecializationAndSupplyTrend',
            method: 'post',
        },
        getDemandAndSupplyPercentageByCountry: {
            path: '/EducationCareerPath/GetDemandAndSupplyPercentageByCountry',
            method: 'post',
        },
        getSupplyOfGraduatesByISCED4: {
            path: '/EducationCareerPath/GetSupplyOfGraduatesByISCED4',
            method: 'post',
        },
        exportSupplyOfGraduatesByISCED4: {
            path: '/EducationCareerPath/ExportSupplyOfGraduatesByISCED4',
            method: 'post',
        },
        getTopSpecializationsBySupply: {
            path: '/EducationCareerPath/GetTopSpecializationsBySupply',
            method: 'post',
        },
        exportTopSpecializationsBySupply: {
            path: '/EducationCareerPath/ExportTopSpecializationsBySupply',
            method: 'post',
        },
        getTopSpecializationsBySupplyJobPostView: {
            path: '/EducationCareerPath/GetTopSpecializationsBySupplyJobPostView',
            method: 'post',
        },
        exportTopSpecializationsBySupplyJobPostView: {
            path: '/EducationCareerPath/ExportTopSpecializationsBySupplyJobPostView',
            method: 'post',
        },
        getTopSpecializationsBySupplyGraduatesView: {
            path: '/EducationCareerPath/GetTopSpecializationsBySupplyGraduatesView',
            method: 'post',
        },
        exportTopSpecializationsBySupplyGraduatesView: {
            path: '/EducationCareerPath/ExportTopSpecializationsBySupplyGraduatesView',
            method: 'post',
        },
        getTotalGraduatesAndStudent: {
            path: '/EducationCareerPath/GetTotalGraduatesAndStudent',
            method: 'post',
        },
        getSupplyEducationLevelPercentage: {
            path: '/EducationCareerPath/GetSupplyEducationLevelPercentage',
            method: 'post',
        },
        getUniversityPrograms: {
            path: '/EducationCareerPath/GetUniversityPrograms',
            method: 'get',
        },
        getSupplyDemandSkills: {
            path: '/EducationCareerPath/GetSupplyDemandSkills',
            method: 'post',
        },
        exportSupplyDemandSkills: {
            path: '/EducationCareerPath/ExportSupplyDemandSkills',
            method: 'post',
        },
    },
    occupationAndSector: {
        getOccupationList: {
            path: '/OccupationAndSector/GetOccupationList',
            method: 'get',
        },
        getMostRequiredISCO4JobInfo: {
            path: '/OccupationAndSector/GetMostRequiredISCO4JobInfo',
            method: 'post',
        },
        getISCO4OccupationAis: {
            path: '/OccupationAndSector/GetISCO4OccupationAis',
            method: 'post',
        },
        getYearlyOccupationTrend: {
            path: '/OccupationAndSector/GetYearlyOccupationTrend',
            method: 'post',
        },
        exportYearlyOccupationTrend: {
            path: '/OccupationAndSector/ExportYearlyOccupationTrend',
            method: 'post',
        },
        getMemberMigrationSectors: {
            path: '/OccupationAndSector/GetMemberMigrationSectors',
            method: 'post',
        },
        exportMemberMigrationSectors: {
            path: '/OccupationAndSector/ExportMemberMigrationSectors',
            method: 'post',
        },
        getMemberMigrationOccupations: {
            path: '/OccupationAndSector/GetMemberMigrationOccupations',
            method: 'post',
        },
        exportMemberMigrationOccupations: {
            path: '/OccupationAndSector/ExportMemberMigrationOccupations',
            method: 'post',
        },
        getTopOccupationsBySectors: {
            path: '/OccupationAndSector/GetTopOccupationsBySectors',
            method: 'post',
        },
        exportTopOccupationsBySectors: {
            path: '/OccupationAndSector/ExportTopOccupationsBySectors',
            method: 'post',
        },
        topNEmployers: {
            path: '/OccupationAndSector/GetTopNEmployers',
            method: 'post',
        },
        exportTopNEmployers: {
            path: '/OccupationAndSector/ExportTopNEmployers',
            method: 'post',
        },
        getJobPostsInfo: {
            path: '/OccupationAndSector/GetJobPostsInfo',
            method: 'post',
        },
        getMostRequiredJobInfo: {
            path: '/OccupationAndSector/GetMostRequiredJobInfo',
            method: 'post',
        },
        exportMostRequiredJobInfo: {
            path: '/OccupationAndSector/ExportMostRequiredJobInfo',
            method: 'post',
        },
        exportISCO4: {
            path: '/OccupationAndSector/ExportISCO4',
            method: 'post',
        },
        getTotalJobPosts: {
            path: '/OccupationAndSector/GetTotalJobPosts',
            method: 'post',
        },
        getTopSectorAndOccupationInfo: {
            path: '/OccupationAndSector/GetTopSectorAndOccupationInfo',
            method: 'post',
        },
        exportTopSectorAndOccupationInfo: {
            path: '/OccupationAndSector/ExportTopSectorAndOccupationInfo',
            method: 'post',
        },
        getISCO3OccupationList: {
            path: '/OccupationAndSector/GetISCO3OccupationList',
            method: 'post',
        },
        getIsco4AIChartData: {
            path: '/OccupationAndSector/GetIsco4AIChartData',
            method: 'post',
        },
        exportIsco4AIChartData: {
            path: '/OccupationAndSector/exportIsco4AIChartData',
            method: 'post',
        },
        getTopIsco3Isco4ByCountry: {
            path: '/OccupationAndSector/getTopIsco3Isco4ByCountry',
            method: 'post',
        },
    },
    "chatAISimulation": {
        addToConversation: {
            path: '/add_to_conversation',
            method: 'get',
        },
        generateScenario: {
            path: '/generate_scenario',
            method: 'get',
        },
        getPlotsResults: {
            path: '/get_results',
            method: 'get',
        },
    }
};

export { endpoints, host, chatAISimulationHost };
